import type { ReactNode } from 'react';
import { Stack } from '@mui/material';

import type { SectionSlots } from '../lease-details.types';

import { SectionHeading } from './section-heading';

export type SectionShellProps = {
  title?: string;
  subtitle?: string;
  slots?: SectionSlots;
  children: ReactNode;
};

// Section frame: a canonical heading (via `SectionHeading`) plus a consistent
// 16px rhythm between the header, slotted content (banners), and the fields.
export const SectionShell = ({ title, subtitle, slots, children }: SectionShellProps) => (
  <Stack direction="column" spacing={2}>
    {slots?.top}
    <SectionHeading title={title} subtitle={subtitle} />
    {slots?.beforeFields}
    {children}
    {slots?.afterFields}
    {slots?.bottom}
  </Stack>
);
